import { render, staticRenderFns } from "./Offer.vue?vue&type=template&id=680b2e42&scoped=true"
import script from "./Offer.vue?vue&type=script&lang=js"
export * from "./Offer.vue?vue&type=script&lang=js"
import style0 from "./Offer.vue?vue&type=style&index=0&id=680b2e42&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680b2e42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('680b2e42')) {
      api.createRecord('680b2e42', component.options)
    } else {
      api.reload('680b2e42', component.options)
    }
    module.hot.accept("./Offer.vue?vue&type=template&id=680b2e42&scoped=true", function () {
      api.rerender('680b2e42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/po/Offer.vue"
export default component.exports